import * as _ from "lodash";
import { useState } from "react";
import World from "../world";
import { MaybeAPIErr } from "../api";

type LoginHook = {
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
    error: MaybeAPIErr;
    isPending: boolean;
}

function useLogin(world: World, onLoginSuccess?: () => void): LoginHook {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<MaybeAPIErr>(null);
    const [isPending, setIsPending] = useState(false);


    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        switch (e.currentTarget.name) {
        case "email":
            setEmail(e.currentTarget.value);
            break;
        case "password":
            setPassword(e.currentTarget.value);
            break;
        }
    }

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setIsPending(true);
        setError(null);

        const err = await world.login({
            email: email,
            password: password,
        });

        setIsPending(false);

        if (err) {
            setError(err);
            return;
        }

        (window as any).fbq("init", 1857456867824784, {
            em: world.host.email,
        });

        if (onLoginSuccess) {
            onLoginSuccess();
        }
    }

    return {
        onChange,
        onSubmit,
        error,
        isPending,
    };
}

export default useLogin;
